import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TitleService {
    private _title: BehaviorSubject<string> = new BehaviorSubject<string>('');

    /**
     * Getter para o observable do título
     */
    get title$(): Observable<string> {
        return this._title.asObservable();
    }

    /**
     * Define o título atual
     */
    setTitle(title: string): void {
        this._title.next(title);
    }
}
